// extracted by mini-css-extract-plugin
export var closeButton = "_mg-2";
export var closeButtonIcon = "_mg-3";
export var lightboxContent = "_mg-1";
export var lightboxOverlay = "_mg-0";